import React from 'react';
import { Check } from 'lucide-react';

interface CheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  error?: string;
  className?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  value,
  onChange,
  label,
  error,
  className,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!value);
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className={`
          relative rounded cursor-pointer transition-all duration-200
          ${error ? 'border-red-500' : ''} 
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''} 
          ${className || ''}
        `}
        onClick={handleClick}
      >
        <div
          className={`
            flex items-center justify-center rounded border-2 transition-all duration-200
            ${value ? 'bg-green-500 border-green-500' : 'bg-white border-gray-300'}
            ${error ? 'border-red-500' : ''}
            ${disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:border-gray-400'}
          `}
          style={{
            width: 20,
            height: 20,
          }}
        >
          {value && (
            <Check
              className="h-4 w-4 text-white"
              strokeWidth={3}
            />
          )}
        </div>
        {label && (
          <label
            className="ml-2 text-sm text-gray-700 cursor-pointer select-none"
            onClick={handleClick}
          >
            {label}
          </label>
        )}
      </div>
      {error && (
        <span className="mt-1 text-xs text-red-500">
          {error}
        </span>
      )}
    </div>
  );
};

export default Checkbox;

